import { FC } from 'react';
import stepIcon from '../../../Assets/StepIcons/Merge.png';
import { NodeLibraryListItem } from '../../Components/NodeLibraryListItem';
import { MERGE_NODE_DESCRIPTION, NodeTypes } from '../../utils';

export const MergeNodeLibraryListItem: FC = () => {
    return <NodeLibraryListItem label='Merge' description={MERGE_NODE_DESCRIPTION} nodeType={NodeTypes.MERGE} imgPath={stepIcon} />
}